var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { CaseApplyManageService } from "~/services/business-service/case-apply-manage.service";
import { Emit, Prop } from "vue-property-decorator";
import { SortService } from "~/utils/sort.service";
import { PageService } from "~/utils/page.service";
import DataBox from "~/components/common/data-box.vue";
var VisitManageOutvisit = /** @class */ (function (_super) {
    __extends(VisitManageOutvisit, _super);
    function VisitManageOutvisit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.userDataSet = [];
        _this.selectionList = [];
        _this.manualModel = {
            batchNum: "",
            closeDate: "",
            companyCode: "",
            type: "",
        };
        _this.visitDataSet = [];
        _this.searchModel = {
            assistStatus: "",
            flowType: "VISIT_APPLY",
        };
        _this.loading = {
            state: false,
        };
        return _this;
    }
    VisitManageOutvisit.prototype.refreshList = function () { };
    VisitManageOutvisit.prototype.close = function () { };
    VisitManageOutvisit.prototype.approvedMeth = function (rowData) { };
    VisitManageOutvisit.prototype.refreshData = function () {
        var _this = this;
        var searchModel = Object.assign(this.searchModel, this.visitModel);
        searchModel.assistCategory = "VISIT_ASSIST";
        searchModel.approvalStatus = "WAIT_APPROVAL"; //未审核
        searchModel.applyDateStart = this.visitModel.applyDate[0];
        searchModel.applyDateEnd = this.visitModel.applyDate[1];
        searchModel.applyDate = "";
        this.caseApplyManageService.getProcessApproveMessage(searchModel, this.pageService, this.sortService, this.loading).subscribe(function (data) {
            _this.visitDataSet = data;
        }, function (_a) {
            var msg = _a.msg;
        });
    };
    //审批操作
    VisitManageOutvisit.prototype.approvedVsisttMeth = function (scope) {
        var rowData = scope.row;
        this.approvedMeth(rowData);
    };
    __decorate([
        Dependencies(SortService)
    ], VisitManageOutvisit.prototype, "sortService", void 0);
    __decorate([
        Dependencies(PageService)
    ], VisitManageOutvisit.prototype, "pageService", void 0);
    __decorate([
        Dependencies(CaseApplyManageService)
    ], VisitManageOutvisit.prototype, "caseApplyManageService", void 0);
    __decorate([
        Emit("refreshList")
    ], VisitManageOutvisit.prototype, "refreshList", null);
    __decorate([
        Emit("close")
    ], VisitManageOutvisit.prototype, "close", null);
    __decorate([
        Emit("approvedMeth")
    ], VisitManageOutvisit.prototype, "approvedMeth", null);
    __decorate([
        Prop()
    ], VisitManageOutvisit.prototype, "visitModel", void 0);
    VisitManageOutvisit = __decorate([
        Component({
            components: {
                DataBox: DataBox,
            },
        })
    ], VisitManageOutvisit);
    return VisitManageOutvisit;
}(Vue));
export default VisitManageOutvisit;
